// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"159df96cd8c78c4a606b","453":"0632f6ac43a863c4f5f8"}[chunkId] + ".js";
};